import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    width: 288, // 4 pulgadas * 72 dpi
    height: 144, // 2 pulgadas * 72 dpi
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    position: 'relative',
  },
  logo: {
    width: 60,
    height: 30,
    marginTop: 10,
    marginBottom: 2,
    alignSelf: 'center',
    objectFit: 'contain',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    marginTop: 4,
    marginBottom: 0,
  },
  qr: {
    width: 70,
    height: 70,
    marginLeft: 18,
    marginRight: 0,
    backgroundColor: 'white',
    padding: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  codeAndBarcode: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginLeft: 30,
    marginTop: 10,
    gap: 0,
  },
  codeText: {
    fontSize: 22,
    fontWeight: 'bold',
    letterSpacing: 1,
    textAlign: 'left',
    maxWidth: 140,
    marginBottom: 6,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  barcode: {
    marginTop: 0,
    width: 140,
    height: 48,
    alignSelf: 'flex-start',
  },
});

const logoAmerisa = require('../assets/logoamerisazul.png');

const EtiquetaDocument = ({ ubicacion, barcodeBase64, qrBase64 }) => (
  <Document>
    <Page size={{ width: 288, height: 144 }} style={styles.page}>
      <Image style={styles.logo} src={logoAmerisa} />
      <View style={styles.row}>
        <View style={styles.qr}>
          {qrBase64 && <Image style={{ width: 70, height: 70 }} src={qrBase64} />}
        </View>
        <View style={styles.codeAndBarcode}>
          <Text style={styles.codeText}>{ubicacion.codigo}</Text>
          {barcodeBase64 && <Image style={styles.barcode} src={barcodeBase64} />}
        </View>
      </View>
    </Page>
  </Document>
);

export default EtiquetaDocument;
